import './center_hero_module.scss';
